export function capitalize(str: string): string {
	const firstLetter = str[ 0 ].toUpperCase();
	const word = str.slice(1);

	return `${firstLetter}${word}`;
}
